import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "./SiteShell";
import styles from "./SiteShell.module.css";
import Seo, { createBreadcrumbList, createWebPageSchema } from "./Seo";
import infoPages from "./infoPages.json";
import {
  createAlternateLinks,
  getBrowserLocale,
  getLocalizedPath,
  translate,
} from "./i18n";

function getPageTranslation(page, locale) {
  return page.translations?.[locale] || page.translations?.de;
}

function InfoPage({ forcedLocale, pageId }) {
  const locale = forcedLocale || getBrowserLocale();
  const page = infoPages.find((item) => item.id === pageId) || infoPages[0];
  const content = getPageTranslation(page, locale);
  const t = (key, values) => translate(locale, key, values);
  const localPath = (path) => getLocalizedPath(path, locale);
  const pagePath = localPath(`/${page.slug}`);

  return (
    <>
      <Seo
        description={content.description}
        path={pagePath}
        alternates={createAlternateLinks((targetLocale) =>
          getLocalizedPath(`/${page.slug}`, targetLocale)
        )}
        structuredData={[
          createWebPageSchema({
            title: content.title,
            description: content.description,
            path: pagePath,
            pageType: page.pageType || "WebPage",
          }),
          createBreadcrumbList([
            { name: t("homeTitle"), path: localPath("/") },
            { name: content.title, path: pagePath },
          ]),
        ]}
        title={content.metaTitle}
      />
      <SiteShell locale={locale}>
        <section className={styles.pageHero}>
          <span className={styles.eyebrow}>{content.eyebrow}</span>
          <h1 className={styles.pageTitle}>{content.title}</h1>
          <p className={styles.pageDescription}>{content.heroText}</p>
          <div className={styles.buttonRow}>
            <Link className={styles.buttonPrimary} to={localPath("/")}>
              {t("backToGallery")}
            </Link>
          </div>
        </section>

        <section className={styles.articleGrid}>
          <article className={styles.copyPanel}>
            <p className={styles.copyLead}>{content.lead}</p>

            <div className={styles.copyStack}>
              {content.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </article>

          <aside className={styles.infoColumn}>
            {content.cards.map((item) => (
              <div className={styles.infoCard} key={`${item.label}-${item.title}`}>
                <span className={styles.infoLabel}>{item.label}</span>
                <h2 className={styles.infoTitle}>{item.title}</h2>
                <p className={styles.infoText}>{item.text}</p>
              </div>
            ))}
          </aside>
        </section>
      </SiteShell>
    </>
  );
}

export default InfoPage;
